/**
 * External dependencies
 */
import { render } from '@wordpress/element';
import './style.scss';

/**
 * Internal dependencies
 */
import CalendarContainer from '../../components/event-calendar/container';
import { decodeAttributesFor } from '../../includes/misc-utils';

const bookingsContainersHTML = document.getElementsByClassName( 'wc-bookings-availability-main-calendar-container' );

for ( const bookingsContainerHTML of bookingsContainersHTML ) {
	const attributes = decodeAttributesFor( 'calendar', bookingsContainerHTML.dataset );
	render( <CalendarContainer { ...attributes } />, bookingsContainerHTML );
}
